export default __webpack_public_path__ + "61fe8205e9d0d7a21a6e2c7d7617fb5d.svg";